var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"result-item",class:{'result-item__active': _vm.isActive}},[_c('router-link',{attrs:{"to":{
    name: 'Address',
    params: { geohash: this.result.geohash, slug: this.result.slug }
  }}},[_vm._v("\n    "+_vm._s(_vm.result.name)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad59e8fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchResults/ResultItem.vue
// module id = null
// module chunks = 